import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Linkedin, Quote } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { recommendationsTranslations } from "@/data/recommendationsTranslations";

const Recommendations = () => {
  const { language, t } = useLanguage();
  const recommendations = recommendationsTranslations[language].recommendations;

  return (
    <section id="recommendations" className="py-20 bg-background/50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            {t('recommendations.title')}
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t('recommendations.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {recommendations.map((recommendation) => (
            <Card key={recommendation.id} className="h-full hover:shadow-lg transition-shadow duration-300 border border-primary/20">
              <CardContent className="p-6 h-full flex flex-col">
                <div className="flex items-start gap-4 mb-4">
                  <Avatar className="w-16 h-16 border-2 border-primary/20">
                    <AvatarImage 
                      src={recommendation.photo} 
                      alt={`${recommendation.name} profile picture`}
                      className="object-cover"
                    />
                    <AvatarFallback className="bg-primary/10 text-primary font-semibold">
                      {recommendation.name.split(' ').map(n => n[0]).join('')}
                    </AvatarFallback>
                  </Avatar>
                  <div className="flex-1">
                    <h3 className="font-semibold text-lg mb-1">{recommendation.name}</h3>
                    <p className="text-sm text-primary font-medium mb-1">{recommendation.role}</p>
                    <p className="text-sm text-muted-foreground">{recommendation.company}</p>
                  </div>
                  <a
                    href={recommendation.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${recommendation.name} LinkedIn profile`}
                    className="text-primary hover:text-primary/80 transition-colors"
                  >
                    <Linkedin className="h-5 w-5" />
                  </a>
                </div>

                <div className="flex-1 relative">
                  <Quote className="h-8 w-8 text-primary/20 absolute -top-2 -left-1" />
                  <blockquote className="text-sm text-muted-foreground leading-relaxed pl-6 italic">
                    "{recommendation.testimony}"
                  </blockquote>
                </div>

                <div className="mt-4 pt-4 border-t border-border">
                  <p className="text-xs text-muted-foreground">
                    <span className="font-medium">{t('recommendations.project')}:</span> {recommendation.project}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Recommendations;